import { useState } from "react";
import { Controller, UseFormReturn } from "react-hook-form";
import { FormControl } from "@material-ui/core";
import { CallListType } from "@bonliva-crm/shared";
import { CallList } from "@consultants/consultant-profile-new/call-list/call-list";
import { EditListModal } from "@consultants/consultant-profile-new/call-list/components/edit-list-modal";
import { CallOrContactList } from "@consultants/consultant-profile-new/call-list/utils";
import { ConsultantAssignCallListFormValues } from "./action-form-values";

type Props = {
  form: UseFormReturn<
    ConsultantAssignCallListFormValues,
    any,
    ConsultantAssignCallListFormValues
  >;
};

type Option = {
  label: string;
  value: CallOrContactList;
};

export const AssignCallListAction = ({ form: { control } }: Props) => {
  const [editListProps, setEditListProps] = useState<{
    callList: CallOrContactList;
    type: CallListType;
  } | null>(null);

  const onOptionEdit = (option: Option, type: CallListType) => {
    setEditListProps({
      callList: option.value,
      type: type
    });
  };

  return (
    <FormControl component="fieldset" style={{ width: "100%" }}>
      <section style={{ marginTop: "16px", width: "100%" }}>
        <Controller
          render={({ field }) => <CallList {...field} onOptionEdit={onOptionEdit} />}
          name="callOrContactLists"
          control={control}
        />

        <EditListModal
          open={!!editListProps}
          onClose={() => setEditListProps(null)}
          {...editListProps}
        />
      </section>
    </FormControl>
  );
};
